import { Box, styled } from "@mui/material";

/** Wrapper for OverviewTable cells, styled specifically for the last cell of a row, use as an alternative to `OverviewTableCell` */
export const OverviewTableCellEnd = styled(Box)(() => ({
  display: "table-cell",
}));
